import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Backdrop, Fade } from '@material-ui/core';
import cx from 'classnames';

import { IconCloseThin } from 'src/assets/icons/CloseThin';
import { CustomIconButton } from 'src/components/CustomIconButton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { GENERATION_PANEL_MENU_TYPE } from 'src/const';
import { useListenToGenerationPanelMenuOpen } from 'src/lib/hooks';
import { useSetupMenuFloating } from 'src/lib/hooks/useSetupMenuFloating';
import pubsub, { PUBSUB } from 'src/lib/pubsub';

import { useStyles } from './useStyles';

export const StylesMenu = ({ className, open, referenceElement, onClose, children }) => {
  const styles = useStyles();

  const [popperElement, setPopperElement] = useState(null);
  const { floatingStyles } = useSetupMenuFloating({
    popperElement,
    referenceElement,
  });

  useListenToGenerationPanelMenuOpen(GENERATION_PANEL_MENU_TYPE.imageStyles, onClose);

  useEffect(() => {
    if (open) {
      pubsub.publish(PUBSUB.OPEN_GENERATION_PANEL_MENU, {
        openedMenuType: GENERATION_PANEL_MENU_TYPE.imageStyles,
      });
    }
  }, [open]);

  return createPortal(
    <>
      <Backdrop
        className={styles.backdrop}
        onClick={onClose}
        open={open}
        invisible
      />

      <Fade
        in={open}
        mountOnEnter
        unmountOnExit
      >
        <div
          className={cx(className, styles.root, {
            [styles.open]: open,
          })}
          ref={setPopperElement}
          style={floatingStyles}
        >
          <div className={styles.header}>
            <CustomTypography variant={TYPOGRAPHY_VARIANT.medium12}>Image style</CustomTypography>

            <CustomIconButton
              className={styles.buttonClose}
              onClick={onClose}
            >
              <IconCloseThin />
            </CustomIconButton>
          </div>

          <div className={styles.children}>{children}</div>
        </div>
      </Fade>
    </>,
    document.body
  );
};
